var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"progress-container text-xs-center"},[_c('v-progress-circular',{attrs:{"color":_vm.color,"indeterminate":"","size":"50"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }